/**
 * Search drawer extras: recent searches and the empty-state toggle.
 *
 * Kept out of predictive-search.js because that file is shared with the /search
 * template and the 404 page; this is drawer-specific behaviour.
 *
 * The predictive-search element replaces its own results markup on every
 * keystroke, so nothing here may live inside it — the suggestions block is a
 * sibling and is toggled with a class on the drawer.
 */
(function () {
	const STORAGE_KEY = 'lip:recent-searches';
	const MAX_RECENT = 6;

	function read() {
		try {
			const raw = window.localStorage.getItem(STORAGE_KEY);
			const parsed = raw ? JSON.parse(raw) : [];
			return Array.isArray(parsed) ? parsed.filter((t) => typeof t === 'string') : [];
		} catch (e) {
			// Private mode, or another origin wrote junk under this key.
			return [];
		}
	}

	function write(terms) {
		try {
			window.localStorage.setItem(STORAGE_KEY, JSON.stringify(terms.slice(0, MAX_RECENT)));
		} catch (e) {
			/* storage unavailable — recents just do not persist */
		}
	}

	function remember(term) {
		const clean = String(term || '').trim();
		if (clean.length < 2) return;
		const terms = read().filter((t) => t.toLowerCase() !== clean.toLowerCase());
		terms.unshift(clean);
		write(terms);
	}

	function init() {
		const drawer = document.getElementById('search-modal');
		if (!drawer || drawer.dataset.searchExtrasBound === 'true') return;
		drawer.dataset.searchExtrasBound = 'true';

		const form = drawer.querySelector('form.search');
		const input = drawer.querySelector('.search__input');
		const recentBlock = drawer.querySelector('[data-search-recent]');
		const recentList = drawer.querySelector('[data-search-recent-list]');
		const clearButton = drawer.querySelector('[data-search-recent-clear]');
		const searchUrl = drawer.dataset.searchUrl || '/search';

		if (!input) return;

		const renderRecent = () => {
			if (!recentBlock || !recentList) return;
			const terms = read();
			recentList.innerHTML = '';

			if (!terms.length) {
				recentBlock.hidden = true;
				return;
			}
			recentBlock.hidden = false;

			terms.forEach((term) => {
				const li = document.createElement('li');
				const link = document.createElement('a');
				link.className = 'search-2026__chip';
				link.href = `${searchUrl}?q=${encodeURIComponent(term)}&options[prefix]=last`;
				link.textContent = term;
				li.appendChild(link);
				recentList.appendChild(li);
			});
		};

		// Suggestions show while the field is empty, results take over once typing.
		const syncState = () => {
			drawer.classList.toggle('search-modal--searching', input.value.trim().length > 0);
		};

		input.addEventListener('input', syncState);
		input.addEventListener('change', syncState);

		if (form) {
			form.addEventListener('submit', () => remember(input.value));
		}

		// A chip is a real link, so remember the term before the navigation.
		drawer.addEventListener('click', (event) => {
			const chip = event.target.closest('.search-2026__chip');
			if (chip) remember(chip.textContent);
		});

		if (clearButton) {
			clearButton.addEventListener('click', () => {
				write([]);
				renderRecent();
			});
		}

		// The theme's reset button empties the field without firing `input`.
		const reset = drawer.querySelector('.reser-search');
		if (reset) {
			reset.addEventListener('click', () => {
				window.setTimeout(syncState, 0);
			});
		}

		renderRecent();
		syncState();
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
	document.addEventListener('shopify:section:load', init);
})();
